import type { UserImageProps } from "@circleco/ui-kit";
import { t } from "@/i18n-js/instance";
import { formatDate } from "@circle-react/components/SettingsApp/ManageMembers/TabContent/Cells/functions";
import { BadgeV2 } from "@circle-react-shared/uikit/BadgeV2";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { Typography } from "@circle-react-uikit/Typography";

type UserImageSizes = UserImageProps["size"];

export const AuthorInfo = ({
  name,
  avatarUrl,
  postName,
  createdAt,
  userImageSize = "6",
  flaggedForApprovalAt,
}: {
  name: string;
  postName: string;
  avatarUrl: string;
  createdAt?: string;
  userImageSize?: UserImageSizes;
  flaggedForApprovalAt?: string;
}) => (
  <div className="flex items-center gap-3">
    <div>
      <UserImage src={avatarUrl} name={name} size={userImageSize} />
    </div>
    <div className="w-[90%]">
      <div className="text-selector-active truncate">
        <Typography.LabelSm leading="leading-3" weight="semibold">
          {name}
        </Typography.LabelSm>{" "}
        <Typography.LabelSm leading="leading-3" color="text-selector-active">
          {t("search_v2.commented_on")}
        </Typography.LabelSm>{" "}
        <Typography.LabelSm leading="leading-3" weight="semibold">
          {postName}
        </Typography.LabelSm>
      </div>
      <div className="leading-3">
        <Typography.LabelXs color="text-selector-active">
          {formatDate(createdAt)}
        </Typography.LabelXs>
        {flaggedForApprovalAt && (
          <BadgeV2
            className="!bg-author-in-review post__headline-tag align ml-2 border-0 align-middle uppercase text-white"
            label={t("in_review")}
          />
        )}
      </div>
    </div>
  </div>
);
